import { Users, CalendarClock } from 'lucide-react'
import { Heading } from '@/components/ui/typography'
import { cn } from '@/lib/utils'
import type { SchedulingMode } from './role-detail-types'

export function RoleModeSection(props: {
  mode: SchedulingMode
  onChange: (mode: SchedulingMode) => void
}) {
  const { mode, onChange } = props
  return (
    <section className="space-y-3">
      <Heading variant="subsection-title">How this role is reached</Heading>
      <div className="grid gap-3 sm:grid-cols-2">
        <ModeCard
          active={mode === 'FAN_OUT'}
          onClick={() => onChange('FAN_OUT')}
          icon={<Users className="h-4 w-4" />}
          title="All members"
          desc="Everyone in this role is reachable everyday when tagged in an action."
        />
        <ModeCard
          active={mode === 'ROTATION'}
          onClick={() => onChange('ROTATION')}
          icon={<CalendarClock className="h-4 w-4" />}
          title="On-call rotation"
          desc="One person is on call each day, set on a calendar below."
        />
      </div>
    </section>
  )
}

function ModeCard(props: {
  active: boolean
  onClick: () => void
  icon: React.ReactNode
  title: string
  desc: string
}) {
  return (
    <button
      type="button"
      onClick={props.onClick}
      className={cn(
        // ring-transparent reserves the ring on both states so selecting a
        // card never changes its rendered size (no pop/jump).
        'flex flex-col gap-1 rounded-lg border p-4 text-left ring-1 ring-transparent transition-colors',
        props.active
          ? 'border-foreground ring-foreground'
          : 'hover:border-foreground/40',
      )}
    >
      <span className="flex items-center gap-2 text-sm font-medium">
        {props.icon}
        {props.title}
      </span>
      <span className="text-xs text-muted-foreground">{props.desc}</span>
    </button>
  )
}
